import Vue from 'vue'
import Vuex from 'vuex'
import userStore from './modules/userStore'
import commonStore from './modules/commonStore'


Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    userStore,
    commonStore
  },
})

export default store

